<template>
  <base-nav
    v-model="showMenu"
    class="navbar-absolute top-navbar"
    type="white"
    :transparent="true"
  >
    <div slot="brand" class="navbar-wrapper" id="TOPPAGE">
      <div class="navbar-minimize d-inline"><sidebar-toggle-button /></div>
      <div
        class="navbar-toggle d-inline"
        :class="{ toggled: $sidebar.showSidebar }"
      >
        <button type="button" class="navbar-toggler" @click="toggleSidebar">
          <span class="navbar-toggler-bar bar1"></span>
          <span class="navbar-toggler-bar bar2"></span>
          <span class="navbar-toggler-bar bar3"></span>
        </button>
      </div>
      <!-- <a class="navbar-brand">{{ routeName }}</a> -->
        <base-button
          v-if="showhome"
          @click.native="$router.push('/');"
          class="edit btn-link"
          size="sm"
          icon
          type="info"
        >
          <i class="fas fa-home"></i>
        </base-button>
      <router-link to='' class="navbar-brand">WEEDO IT</router-link>
      <label>Bêta</label>
      <!-- switsh role af to an -->
      <template v-if="hasMultiLaw">
        <button class="btn btn-neutral btn-simple fontsizeLawS" :disabled="disabledSwitch"  v-if="CurrentLaw == 'an'" @click="SwitchToEditeur">
          <i class="fas fa-exchange-alt"></i>  PASSER EN MODE EDITEUR
        </button>
        <button class="btn btn-neutral btn-simple fontsizeLawS" :disabled="disabledSwitch" v-if="CurrentLaw == 'af'" @click="SwitchToAnnonceur">
          <i class="fas fa-exchange-alt"></i>  PASSER EN MODE ANNONCEUR
        </button>
      </template>
    </div>

    <ul class="navbar-nav" :class="$rtl.isRTL ? 'mr-auto' : 'ml-auto'">
      <SoldeLeadMarket />
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      <!-- <div class="row">
        <div class="notification-number">10</div>
        <button class="btn btn-icon btn-round btn-market">
          
          <i class="fas fa-shopping-cart"></i>
        </button>
      </div> -->
      <el-tooltip :content="'Actuellement vous avez '+ ($store.state.LeadsPanier_trio + $store.state.LeadsPanier_duo + $store.state.LeadsPanier_exclusif)+' leads dans votre panier'" effect="light" :open-delay="300" placement="top">
        <base-button
          size="sm"
          type="transparent"
          style="border-radius: 5px"
        >
          <div class="notification-number"> {{ $store.state.LeadsPanier_trio + $store.state.LeadsPanier_duo + $store.state.LeadsPanier_exclusif }} </div>
          <i class="fas fa-shopping-cart whitcontent" style="vertical-align: middle;font-size: 22px; width: 35px;"></i>
        </base-button>
      </el-tooltip>
      

      <!-- <base-dropdown
        tag="li"
        :menu-on-right="!$rtl.isRTL"
        title-tag="a"
        class="nav-item"
        title-classes="nav-link"
        menu-classes="dropdown-navbar"
      >
        <template
          slot="title"
        >
          <div class="notification-number">{{ $store.state.LeadsPanier_trio + $store.state.LeadsPanier_duo + $store.state.LeadsPanier_exclusif }}</div>
          <i class="fas fa-shopping-cart"></i>
        </template>
        <li class="nav-link">
          Actuellement vous avez {{ $store.state.LeadsPanier_trio + $store.state.LeadsPanier_duo + $store.state.LeadsPanier_exclusif }} leads dans votre panier
        </li>
      </base-dropdown> -->
      <!-- <div class="search-bar input-group" @click="searchModalVisible = true"> -->
        <!--
          <input type="text" class="form-control" placeholder="Search...">
          <div class="input-group-addon"><i class="tim-icons icon-zoom-split"></i></div>
        -->
        <!-- <button
          class="btn btn-link"
          id="search-button"
          data-toggle="modal"
          data-target="#searchModal"
        >
          <i class="tim-icons icon-zoom-split"></i>
        </button> -->
        <!-- You can choose types of search input -->
      <!-- </div> -->
      <modal
        :show.sync="searchModalVisible"
        class="modal-search"
        id="searchModal"
        :centered="false"
        :show-close="true"
      >
        <input
          slot="header"
          v-model="searchQuery"
          type="text"
          class="form-control"
          id="inlineFormInputGroup"
          placeholder="CHERCHER"
        />
      </modal>
      <base-button
        size="sm"
        :type="(nb_notifAn) ? 'notif' : 'transparent'"
        style="border-radius: 5px"
        @click="ShowNotif = true"
      >
        <div class="notification"></div>
        <i class="fas fa-bell whitcontent" style="vertical-align: middle;font-size: 22px; width: 35px;"></i>
      </base-button>
      <label class="whitcontent ml-2 d-none d-lg-block d-xl-block">
        {{ $t('labels.Welcome') }} <u>{{ replaceUTF_8(First_name) }} {{ (Last_name) ? replaceUTF_8(Last_name).toUpperCase() : Last_name }} </u><br>
        {{ $t('table.columns.Society') }} : {{ (society) ? replaceUTF_8(society).toUpperCase() : society }}
      </label>
      <label class="d-lg-none">
        {{ $t('labels.Welcome') }} <u>{{ replaceUTF_8(First_name) }} {{ (Last_name) ? replaceUTF_8(Last_name).toUpperCase() : Last_name }} </u><br>
        {{ $t('table.columns.Society') }} : {{ (society) ? replaceUTF_8(society).toUpperCase() : society }}
      </label>
      <base-dropdown
        tag="li"
        :menu-on-right="!$rtl.isRTL"
        title-tag="a"
        class="nav-item"
        title-classes="nav-link"
        menu-classes="dropdown-navbar"
      >
        <template
          slot="title"
        >
          <div class="photo"><img :src="imageUrl" /></div>
          <b class="caret d-none d-lg-block d-xl-block"></b>
          <p class="d-lg-none">menu</p>
        </template>
        <li class="nav-link">
          <router-link :to="{ name: 'User Profile' }">
            <a href="" class="nav-item dropdown-item">
              <i class="tim-icons icon-trophy"></i>
              {{ $t("labels.Profile") }}
            </a>
          </router-link>
        </li>
        <li class="nav-link">
          <!-- <a href="#" class="nav-item dropdown-item">
            <i class="tim-icons icon-settings-gear-63"></i>
            Settings
          </a> -->
        </li>
        <div class="dropdown-divider"></div>
        <li class="nav-link">
          <a @click="signOut" style="cursor: pointer;" class="nav-item dropdown-item">
            <i class="tim-icons icon-settings-gear-63"></i>
            {{ $t("buttons.signOut") }}
          </a>
        </li>
      </base-dropdown>
    </ul>
    <modal
      :show.sync="ShowNotif"
      class="modal-notice"
      footerClasses="justify-content-center"
      type="notice"
    >
    <!-- type="mini" -->
      <h3 slot="header" class="title_notif">
        Notifications
      </h3>
      <li class="list-notif">
        
        <!-- Annonceur notification -->
        <template v-if="CurrentLaw === 'an'">
          <Notif_An @nb_notifAn="emit_notifAn"></Notif_An>
        </template>
        <!-- Annonceur notification -->

      </li>
    </modal>
  </base-nav>
</template>
<script>
import { CollapseTransition } from 'vue2-transitions';
import { BaseNav, Modal } from '@/components';
import SidebarToggleButton from './SidebarToggleButton';
import Notif_An from './Notification/Notification_Annonceur'
import SoldeLeadMarket from './Notification/SoldeLeadMarket'
 
export default {
  watch: {
    '$route' () {
      if(this.$router.currentRoute.path === "/dashboard" || this.$router.currentRoute.path ===  "/dashboard-annonceur" || this.$router.currentRoute.path === "/dashboard-editeur") {
        this.showhome = false
      }
      else {
        this.showhome = true
      }
    }
  },
  created() {
    if(this.$router.currentRoute.path === "/dashboard" || this.$router.currentRoute.path ===  "/dashboard-annonceur" || this.$router.currentRoute.path === "/dashboard-editeur") {
      this.showhome = false
    }
    else {
      this.showhome = true
    }
  },
  components: {
    SidebarToggleButton,
    CollapseTransition,
    BaseNav,
    Modal,
    Notif_An,
    SoldeLeadMarket
  },
  computed: {
    routeName() {
      const { name } = this.$route;
      return this.capitalizeFirstLetter(name);
    },
    isRTL() {
      return this.$rtl.isRTL;
    }
  },
  data() {
    return {
      nb_notifAn: 0,
      showhome: false,
      ShowNotif: false,
      activeNotifications: false,
      showMenu: false,
      searchModalVisible: false,
      searchQuery: '',
      CurrentLaw: JSON.parse(localStorage.getItem('utilisateur')).law,
      hasMultiLaw: JSON.parse(localStorage.getItem('utilisateur')).multi_droit,
      imageUrl: JSON.parse(localStorage.getItem('utilisateur')).image,
      First_name: JSON.parse(localStorage.getItem('utilisateur')).first_name,
      Last_name: JSON.parse(localStorage.getItem('utilisateur')).last_name,
      id: JSON.parse(localStorage.getItem('utilisateur')).id,
      society: JSON.parse(localStorage.getItem('utilisateur')).society,
      disabledSwitch: false,
    };
  },
  methods: {
    emit_notifAn(nb_notifAn) {
      this.nb_notifAn = nb_notifAn
    },
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    toggleNotificationDropDown() {
      this.activeNotifications = !this.activeNotifications;
    },
    closeDropDown() {
      this.activeNotifications = false;
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar() {
      this.$sidebar.displaySidebar(false);
    },
    toggleMenu() {
      this.showMenu = !this.showMenu;
    },
    signOut () {
      this.$store.commit('signOut')
      location.reload()
    },
    async SwitchToEditeur() {
      if(this.sendAxios('af')) {
        await this.sleep(2000);
        // this.$router.push({name: "Editeur Dashboard"})
        // let routeData = this.$router.resolve({name: "Editeur Dashboard"});
        // window.open(routeData.href);
        this.disabledSwitch = false
        window.location.replace("/")
      }
    },
    async SwitchToAnnonceur() {
      if(this.sendAxios('an')) {
        await this.sleep(2000);
        // this.$router.push({name: "Annonceur Dashboard"})
        // let routeData = this.$router.resolve({name: "Annonceur Dashboard"});
        // window.open(routeData.href);
        this.disabledSwitch = false
        window.location.replace("/")
      }
    },
    async sendAxios(law) {
      this.disabledSwitch = true
      let token = localStorage.getItem('token_jwt')
      let formData = new FormData()
      formData.append('id',JSON.parse(localStorage.getItem('utilisateur')).id)
      formData.append('law',law)
      let valide = false
      await this.axios.post("https://api-auth-plf.wee-do-it.net/api/v1/switch_law",formData,{
        headers: { 
          'authorization': `Bearer ${token}` 
        },
      })
      .then(response => {
        if (response.data.code == "U200_02") {
          let utilisateur = JSON.parse(localStorage.getItem('utilisateur'))
          utilisateur.law = response.data.response.utilisateur.law
          utilisateur.id_clien_myaffil = response.data.response.utilisateur.id_clien_myaffil
          localStorage.setItem('utilisateur', JSON.stringify(utilisateur))
          // this.CurrentLaw = response.data.response.utilisateur.law
          valide =  true
        }
      })
      .catch(err => {
        console.log(err)
        valide = false
      })
      return valide
    },
    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },
    replaceUTF_8(string) {
      if(!string) 
        return ''

      for (const [key, value] of Object.entries(this.$store.state.UT8_array)) {
        string = string.replaceAll(value, key)
      }
      
      return string
    }
  }
};
</script>
<style scoped>
.top-navbar {
  top: 0px;
}
@media only screen and (max-device-width : 640px) {
  .fontsizeLawS{
    font-size: 10px;
    width: 100px
  }
}

.list-notif {
  list-style-type: none;
  padding: 0;
  margin: 0;
}

</style>
